import { render, staticRenderFns } from "./StrangerQuery.vue?vue&type=template&id=19c13fae&scoped=true&"
import script from "./StrangerQuery.vue?vue&type=script&lang=js&"
export * from "./StrangerQuery.vue?vue&type=script&lang=js&"
import style1 from "./StrangerQuery.vue?vue&type=style&index=1&id=19c13fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c13fae",
  null
  
)

export default component.exports